// extracted by mini-css-extract-plugin
export default {"ApplicationMain__Root":"ApplicationMain_ApplicationMain__Root__ka6Eq"};